import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { styled } from '@miro-site/ui-styled-engine';
import { ChevronUp, Container, Link } from '@miro-site/ui-core';
import { useContentfulData } from '@miro-site/core';
import JSONLD from './JsonLD';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PageLink = styled(Link, {
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '14px',
  textTransform: 'capitalize',
  '&::hover': {
    svg: {
      color: '$font-default-hover'
    }
  },
  svg: {
    color: '$font-primary',
    position: 'relative',
    top: '-1px'
  }
});
var Seperator = styled('span', {
  display: 'inline-block',
  fontSize: '14px',
  marginX: '$100',
  transform: 'rotate(90deg)',
  position: 'relative',
  top: '6px',
  svg: {
    width: '16px'
  }
});

var BreadCrumb = function BreadCrumb(props) {
  var _contentfulData$page, _contentfulData$page$;

  var contentfulData = useContentfulData();
  var paths = (contentfulData === null || contentfulData === void 0 ? void 0 : (_contentfulData$page = contentfulData.page) === null || _contentfulData$page === void 0 ? void 0 : (_contentfulData$page$ = _contentfulData$page.fields) === null || _contentfulData$page$ === void 0 ? void 0 : _contentfulData$page$.siteUrl) || '';
  var localeDetected = '';
  var accumulator = 'https://miro.com'; //url starts with '/' in EN locale else it starts with /{LOCALE}

  var allLocales = contentfulData === null || contentfulData === void 0 ? void 0 : contentfulData.allLocales;

  var createPaths = function createPaths(path) {
    var paths = path ? path.split('/') : [];

    if (!paths || paths.length === 0) {
      return [];
    }

    if (paths && paths.length) {
      if (allLocales.indexOf(paths[0]) !== -1) {
        localeDetected = paths[0];
        paths.splice(0, 1);
        accumulator = accumulator + '/' + localeDetected + '/';
      } else {
        accumulator = accumulator + '/';
      }

      return paths;
    }
  };

  var pagePaths = paths ? createPaths(paths) : [];

  var generateJSONLDProps = function generateJSONLDProps() {
    if (!pagePaths || pagePaths.length === 0) {
      return;
    }

    var urlAccumalator = accumulator;
    var finalJson = {
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: props.homeKeyWord || 'Home',
        item: urlAccumalator
      }]
    };
    pagePaths === null || pagePaths === void 0 ? void 0 : pagePaths.forEach(function (path, index) {
      urlAccumalator = urlAccumalator + path + '/';
      finalJson.itemListElement.push({
        '@type': 'ListItem',
        position: index + 2,
        //There is home page position 1 always
        name: path === null || path === void 0 ? void 0 : path.replace(/-/g, ' '),
        item: urlAccumalator
      });
    });
    return finalJson;
  };

  return /*#__PURE__*/_jsxs(Container, {
    css: {
      paddingY: '$150',
      overflow: 'auto',
      whiteSpace: 'nowrap'
    },
    children: [/*#__PURE__*/_jsx(JSONLD, _objectSpread({
      type: "BreadcrumbList"
    }, generateJSONLDProps())), pagePaths.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(PageLink, {
        href: accumulator,
        variant: "light",
        css: {
          position: 'relative',
          top: '2px'
        },
        children: [/*#__PURE__*/_jsxs("svg", {
          width: "13",
          height: "13",
          viewBox: "0 0 13 13",
          fill: "#686685",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M2.40909 6.64941C2.63503 6.64941 2.81818 6.87327 2.81818 7.14941V10.1494C2.81818 10.9778 3.36765 11.6494 4.04545 11.6494H8.95455C9.63235 11.6494 10.1818 10.9778 10.1818 10.1494V7.14941C10.1818 6.87327 10.365 6.64941 10.5909 6.64941C10.8168 6.64941 11 6.87327 11 7.14941V10.1494C11 11.5301 10.0842 12.6494 8.95455 12.6494H4.04545C2.91578 12.6494 2 11.5301 2 10.1494V7.14941C2 6.87327 2.18316 6.64941 2.40909 6.64941Z",
            fill: "currentColor"
          }), /*#__PURE__*/_jsx("path", {
            d: "M6.5 0.350586L12.8536 6.70414C13.0488 6.8994 13.0488 7.21598 12.8536 7.41125C12.6583 7.60651 12.3417 7.60651 12.1464 7.41125L6.5 1.7648L0.853553 7.41125C0.658291 7.60651 0.341709 7.60651 0.146447 7.41125C-0.0488155 7.21598 -0.0488155 6.8994 0.146447 6.70414L6.5 0.350586Z",
            fill: "currentColor"
          })]
        }), props.homeKeyWord || 'Home']
      }, "breadcrump-home"), /*#__PURE__*/_jsx(Seperator, {
        children: /*#__PURE__*/_jsx(ChevronUp, {})
      })]
    }), pagePaths.length > 0 && pagePaths.map(function (path, index) {
      accumulator = accumulator + path + '/';
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(PageLink, {
          disabled: index === pagePaths.length - 1,
          variant: "light",
          href: accumulator,
          children: path === null || path === void 0 ? void 0 : path.replace(/-/g, ' ')
        }, 'breadcrump-' + index), index !== pagePaths.length - 1 && /*#__PURE__*/_jsx(Seperator, {
          children: /*#__PURE__*/_jsx(ChevronUp, {})
        })]
      });
    })]
  });
};

export default BreadCrumb;